import { CapoPlugin } from "/app/anybill-partner-portal-v3/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];